export const NORMAL_SIZE = {
  'devui-font-size': '12px',
  'devui-font-size-card-title': '14px',
  'devui-font-size-page-title': '16px',
  'devui-font-size-modal-title': '18px',
  'devui-font-size-price': '20px',
  'devui-font-size-data-overview': '24px',
  'devui-font-size-icon': '16px',
  'devui-font-size-sm': '12px',
  'devui-font-size-md': '12px',
  'devui-font-size-lg': '14px',
};


export const MEDIUM_SIZE = {
  'devui-font-size': '14px',
  'devui-font-size-card-title': '16px',
  'devui-font-size-page-title': '18px',
  'devui-font-size-modal-title': '20px',
  'devui-font-size-price': '22px',
  'devui-font-size-data-overview': '26px',
  'devui-font-size-icon': '18px',
  'devui-font-size-sm': '14px',
  'devui-font-size-md': '14px',
  'devui-font-size-lg': '16px',
}

export const LARGE_SIZE = {
  'devui-font-size': '16px',
  'devui-font-size-card-title': '18px',
  'devui-font-size-page-title': '20px',
  'devui-font-size-modal-title': '22px',
  'devui-font-size-price': '24px',
  'devui-font-size-data-overview': '28px',
  'devui-font-size-icon': '20px',
  'devui-font-size-sm': '16px',
  'devui-font-size-md': '16px',
  'devui-font-size-lg': '18px',
};

export const NORMAL_RADIUS = {
  'devui-border-radius': "4px",
  'devui-border-radius-card': "4px"
}

export const MEDIUM_RADIUS = {
  'devui-border-radius': "6px",
  'devui-border-radius-card': "6px"
}

export const LARGE_RADIUS = {
  'devui-border-radius': "8px",
  'devui-border-radius-card': "8px"
}

